(function () {
  if (window.SisBfBundle) return;
  window.SisBfBundle = true;

  var LIMIT = 3;

  function pickerFrom(node) {
    return node.closest('[data-sis-bf-picker]');
  }

  function selected(root, group) {
    return Array.prototype.slice.call(
      root.querySelectorAll('[data-sis-bf-option][data-group="' + group + '"][aria-pressed="true"]')
    );
  }

  function needsFlash(kind) {
    return kind === '199' || kind === '249';
  }

  function needsManual(kind) {
    return kind === '149' || kind === '199' || kind === '249';
  }

  function isReady(root) {
    var kind = root.getAttribute('data-kind');
    var variantId = root.getAttribute('data-variant-id');
    if (!kind || !variantId) return false;
    if (needsFlash(kind) && selected(root, 'flashcard').length !== LIMIT) return false;
    if (needsManual(kind) && selected(root, 'manual').length !== LIMIT) return false;
    if (kind === '249' && root.querySelectorAll('[data-sis-bf-digital]').length !== LIMIT) return false;
    return true;
  }

  function sync(root) {
    ['flashcard', 'manual'].forEach(function (group) {
      var items = selected(root, group);
      var count = root.querySelector('[data-sis-bf-count="' + group + '"]');
      if (count) count.textContent = String(items.length);
      root.querySelectorAll('[data-sis-bf-option][data-group="' + group + '"]').forEach(function (button) {
        var pressed = button.getAttribute('aria-pressed') === 'true';
        button.disabled = !pressed && items.length >= LIMIT;
      });
    });

    var add = root.querySelector('[data-sis-bf-add]');
    if (add && root.getAttribute('data-busy') !== 'true') add.disabled = !isReady(root);
  }

  function clearSelection(root) {
    root.querySelectorAll('[data-sis-bf-option]').forEach(function (button) {
      button.setAttribute('aria-pressed', 'false');
      button.disabled = false;
    });
    var qty = root.querySelector('[data-sis-bf-qty]');
    if (qty) qty.value = '1';
    var error = root.querySelector('[data-sis-bf-error]');
    if (error) error.textContent = '';
    sync(root);
  }

  function openFromCard(card) {
    var dialog = document.querySelector('[data-sis-bf-dialog]');
    if (!dialog) return;
    var root = dialog.querySelector('[data-sis-bf-picker]');
    if (!root) return;
    root.setAttribute('data-kind', card.getAttribute('data-kind') || '');
    root.setAttribute('data-variant-id', card.getAttribute('data-variant-id') || '');
    var title = dialog.querySelector('[data-sis-bf-dialog-title]');
    var current = dialog.querySelector('[data-sis-bf-dialog-current]');
    var compare = dialog.querySelector('[data-sis-bf-dialog-compare]');
    if (title) title.textContent = card.getAttribute('data-title') || '';
    if (current) current.textContent = card.getAttribute('data-price') || '';
    if (compare) {
      var compareText = card.getAttribute('data-compare') || '';
      compare.textContent = compareText;
      compare.hidden = compareText === '';
    }
    clearSelection(root);
    hideIncludedNotes();
    if (typeof dialog.showModal === 'function') dialog.showModal();
  }

  function propertiesFor(root) {
    var kind = root.getAttribute('data-kind');
    var props = {};
    var handles = [];

    function take(group, label) {
      var handlesInGroup = [];
      selected(root, group).forEach(function (button, index) {
        props[label + ' ' + (index + 1)] = button.getAttribute('data-title') || '';
        handlesInGroup.push(button.getAttribute('data-handle') || '');
      });
      handles.push(group + ':' + handlesInGroup.join(','));
    }

    if (needsFlash(kind)) take('flashcard', 'Flashcard');
    if (needsManual(kind)) take('manual', 'Manual');
    if (kind === '249') {
      var digitalHandles = [];
      root.querySelectorAll('[data-sis-bf-digital]').forEach(function (item, index) {
        props['Produs digital ' + (index + 1)] = item.getAttribute('data-title') || '';
        digitalHandles.push(item.getAttribute('data-handle') || '');
      });
      handles.push('digital:' + digitalHandles.join(','));
    }

    props._handles = handles.join(';');
    props._bundle = 'sis-bf-' + kind;
    return props;
  }

  function quantityFor(root) {
    var input = root.querySelector('[data-sis-bf-qty]');
    var qty = input ? parseInt(input.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;
    return qty;
  }

  function finishAdd(root, dialog) {
    root.setAttribute('data-busy', 'false');
    sync(root);
    if (dialog && dialog.open) dialog.close();
  }

  function failAdd(root) {
    root.setAttribute('data-busy', 'false');
    sync(root);
    var error = root.querySelector('[data-sis-bf-error]');
    if (error) error.textContent = 'Nu am putut adăuga pachetul. Încearcă din nou.';
  }

  function addBundle(root) {
    if (!isReady(root) || root.getAttribute('data-busy') === 'true') return;
    var variantId = root.getAttribute('data-variant-id');
    var props = propertiesFor(root);
    var qty = quantityFor(root);
    var dialog = root.closest('dialog');
    var add = root.querySelector('[data-sis-bf-add]');
    root.setAttribute('data-busy', 'true');
    if (add) add.disabled = true;

    var request;
    if (window.SisCart && typeof window.SisCart.addItem === 'function') {
      request = window.SisCart.addItem(variantId, qty, { properties: props });
    } else {
      request = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty, properties: props })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart_request_failed');
        return response.json();
      });
    }

    request.then(function () {
      finishAdd(root, dialog);
    }, function () {
      failAdd(root);
    });
  }

  function hideIncludedNotes() {
    document.querySelectorAll('[data-sis-bf-included-note]').forEach(function (note) {
      note.hidden = true;
      note.classList.remove('is-below');
    });
    document.querySelectorAll('[data-sis-bf-digital][aria-expanded="true"]').forEach(function (item) {
      item.setAttribute('aria-expanded', 'false');
    });
  }

  function showIncludedNote(item) {
    var root = pickerFrom(item);
    if (!root) return;
    var note = root.querySelector('[data-sis-bf-included-note]');
    if (!note) return;
    var alreadyOpen = !note.hidden && note.parentElement === item;
    hideIncludedNotes();
    if (alreadyOpen) return;
    item.appendChild(note);
    note.hidden = false;
    item.setAttribute('aria-expanded', 'true');
    var bounds = (root.closest('dialog') || root).getBoundingClientRect();
    if (note.getBoundingClientRect().top < bounds.top + 4) note.classList.add('is-below');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-sis-bf-included-note]')) return;

    var digital = event.target.closest('[data-sis-bf-digital]');
    if (digital) {
      event.preventDefault();
      showIncludedNote(digital);
      return;
    }

    hideIncludedNotes();

    var opener = event.target.closest('[data-sis-bf-open]');
    if (opener) {
      event.preventDefault();
      if (opener.disabled) return;
      openFromCard(opener);
      return;
    }

    var closer = event.target.closest('[data-sis-bf-close]');
    if (closer) {
      var dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    var option = event.target.closest('[data-sis-bf-option]');
    if (!option || option.disabled) return;
    var root = pickerFrom(option);
    if (!root) return;
    var pressed = option.getAttribute('aria-pressed') === 'true';
    if (!pressed && selected(root, option.getAttribute('data-group')).length >= LIMIT) return;
    option.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    sync(root);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-sis-bf-picker]');
    if (!form) return;
    event.preventDefault();
    addBundle(form);
  });

  document.addEventListener('keydown', function (event) {
    var digital = event.target.closest('[data-sis-bf-digital]');
    if (digital && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      showIncludedNote(digital);
      return;
    }
    if (event.key === 'Escape') hideIncludedNotes();
  });

  document.querySelectorAll('[data-sis-bf-dialog]').forEach(function (dialog) {
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', hideIncludedNotes);
  });

  document.querySelectorAll('[data-sis-bf-picker]').forEach(sync);
})();
